import { Grid } from '@mui/material';
import React from 'react';
import Gene20Box from '../../Components/Gene20Box/Gene20Box';
import shopsData from '../TheMall/data/shopsData';
import ClothesAndJewellery from './categories/clothes&jewellery';

export default function MallShops() {
  return (
    <Grid container>
      {shopsData.map((item, index) => (
        <Grid item xs={12} sm={4}>
          <ClothesAndJewellery item={item} index={index} />
        </Grid>
      ))}
    </Grid>
  );
}
